import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }

import { ref, computed, watch, onMounted } from "vue";
import { useSendFileDialogStore } from "@/store/sendFileDialog";
import { useContactsStore } from "@/store/contacts";
import { useDisplay } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'SendFileDialog',
  setup(__props) {

const sendFileDialogStore = useSendFileDialogStore();
const contactsStore = useContactsStore();

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const formTitle = computed(() => sendFileDialogStore.formTitle);
const client_id = computed(() => sendFileDialogStore.client_id);

const formState = computed(() => sendFileDialogStore.isOpen);

const loading = ref(false);
const contactsList = ref<any[]>([]);
const selectedContactIds = ref<any[]>([]);

const selectedContacts = computed(() =>
  contactsList.value.filter(c => selectedContactIds.value.includes(c.id))
);

const fetchContacts = async () => {
  loading.value = true;
  contactsList.value = [];
  if (client_id.value) {
    await contactsStore.fetchContactByClientId(Number(client_id.value));
    // Agrega el main_email si lo tienes
    if (sendFileDialogStore.main_email) {
      contactsList.value = [
        {
          id: 'main',
          name: 'Email Principal',
          email: sendFileDialogStore.main_email,
        },
        ...contactsStore.contacts, // debe tener id, name, email, whatsapp
      ];
    } else {
      contactsList.value = contactsStore.contacts;
    }
  }
  loading.value = false;
};

watch(formState, (open) => {
  if (open) fetchContacts();
});

const sendEmail = async () => {
  if (typeof sendFileDialogStore.onSendEmail === 'function') {
    await sendFileDialogStore.onSendEmail(selectedContacts.value);
    sendFileDialogStore.closeForm();
  }
};

const sendWhatsapp = async () => {
  if (typeof sendFileDialogStore.onSendWhatsapp === 'function') {
    await sendFileDialogStore.onSendWhatsapp(selectedContacts.value);
    sendFileDialogStore.closeForm();
  }
};

const close = () => sendFileDialogStore.closeForm();

const missingEmailContacts = computed(() =>
  selectedContacts.value.filter(c => !c.email)
);
const missingWhatsappContacts = computed(() =>
  selectedContacts.value.filter(c => !c.phone && !c.whatsapp)
);

const canSendEmail = computed(() =>
  selectedContacts.value.length > 0 && missingEmailContacts.value.length === 0
);
const canSendWhatsapp = computed(() =>
  selectedContacts.value.length > 0 && missingWhatsappContacts.value.length === 0
);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: formState.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState).value = $event)),
    "max-width": 800,
    fullscreen: isMobile.value,
    scrollable: "",
    transition: isMobile.value?'dialog-bottom-transition':'fade-transition'
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formTitle.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Cargando contactos..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactsList.value, (contact) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: contact.id
                          }, {
                            append: _withCtx(() => [
                              (contact.phone)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "📱 " + _toDisplayString(contact.phone), 1))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: selectedContactIds.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedContactIds).value = $event)),
                                label: contact.name + (contact.email ? ' - ' + contact.email : ''),
                                value: contact.id,
                                density: "compact"
                              }, null, 8, ["modelValue", "label", "value"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                color: "red",
                onClick: close
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Cancelar")
                ])),
                _: 1,
                __: [2]
              }),
              _createVNode(_component_v_spacer),
              (selectedContacts.value.length && !canSendEmail.value)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                        _createVNode(_component_v_btn, {
                          color: "success",
                          disabled: !canSendEmail.value,
                          onClick: sendEmail
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" Enviar Email ")
                          ])),
                          _: 1,
                          __: [3]
                        }, 8, ["disabled"])
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _cache[4] || (_cache[4] = _createTextVNode(" Los siguientes contactos no tienen email:")),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missingEmailContacts.value, (c) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: c.id
                          }, _toDisplayString(c.name || c.email || c.phone), 1))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    color: "success",
                    disabled: selectedContacts.value.length === 0,
                    onClick: sendEmail
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Enviar Email ")
                    ])),
                    _: 1,
                    __: [6]
                  }, 8, ["disabled"])),
              (selectedContacts.value.length && !canSendWhatsapp.value)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 2,
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          disabled: !canSendWhatsapp.value,
                          onClick: sendWhatsapp
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode(" Enviar WhatsApp ")
                          ])),
                          _: 1,
                          __: [7]
                        }, 8, ["disabled"])
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _cache[8] || (_cache[8] = _createTextVNode(" Los siguientes contactos no tienen WhatsApp:")),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missingWhatsappContacts.value, (c) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: c.id
                          }, _toDisplayString(c.name || c.email || c.phone), 1))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    color: "primary",
                    disabled: selectedContacts.value.length === 0,
                    onClick: sendWhatsapp
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Enviar WhatsApp ")
                    ])),
                    _: 1,
                    __: [10]
                  }, 8, ["disabled"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "fullscreen", "transition"]))
}
}

})